module.exports = __webpack_public_path__ + "img/approved.fcd52e49.svg";